export interface AMBestRatingInfo {
  title: string;
  description: string;
}

export const AM_BEST_RATING_INFO: Record<string, AMBestRatingInfo> = {
  "A++": {
    "title": "A++ (Superior) – AM Best Rating",
    "description": "This insurer is rated A++ (Superior) by AM Best, indicating a superior ability to meet its ongoing insurance obligations. A++ is AM Best's highest Financial Strength Rating."
  },
  "A+": {
    "title": "A+ (Superior) – AM Best Rating",
    "description": "This insurer is rated A+ (Superior) by AM Best, meaning it has a strong ability to meet ongoing insurance obligations. A+ is one of the highest possible ratings."
  },
  "A": {
    "title": "A (Excellent) – AM Best Rating",
    "description": "This insurer is rated A (Excellent) by AM Best, meaning it has an excellent ability to meet ongoing insurance obligations."
  },
  "A-": {
    "title": "A- (Excellent) – AM Best Rating",
    "description": "This insurer is rated A- (Excellent) by AM Best, signifying an excellent ability to meet ongoing insurance obligations, though at the lower end of the Excellent category."
  },
  "B++": {
    "title": "B++ (Good) – AM Best Rating",
    "description": "This insurer is rated B++ (Good) by AM Best, meaning it has a good ability to meet ongoing insurance obligations and sits at the top of the Good category."
  },
  "B+": {
    "title": "B+ (Good) – AM Best Rating",
    "description": "This insurer is rated B+ (Good) by AM Best, indicating a good ability to meet ongoing insurance obligations, but with somewhat less financial strength than B++."
  },
  "B": {
    "title": "B (Fair) – AM Best Rating",
    "description": "This insurer is rated B (Fair) by AM Best, pointing to a fair ability to meet ongoing insurance obligations and heightened sensitivity to adverse economic conditions."
  },
  "B-": {
    "title": "B- (Fair) – AM Best Rating",
    "description": "This insurer is rated B- (Fair) by AM Best, reflecting a fair but fragile ability to meet ongoing insurance obligations and significant vulnerability to adverse events."
  },
  "C++": {
    "title": "C++ (Marginal) – AM Best Rating",
    "description": "This insurer is rated C++ (Marginal) by AM Best, indicating a marginal ability to meet ongoing insurance obligations and limited financial flexibility."
  },
  "C+": {
    "title": "C+ (Marginal) – AM Best Rating",
    "description": "This insurer is rated C+ (Marginal) by AM Best, meaning its ability to meet ongoing insurance obligations is marginal and highly vulnerable to adverse conditions."
  },
  "C": {
    "title": "C (Weak) – AM Best Rating",
    "description": "This insurer is rated C (Weak) by AM Best, signifying a weak ability to meet ongoing insurance obligations and a very limited capacity to withstand unfavorable changes."
  },
  "C-": {
    "title": "C- (Weak) – AM Best Rating",
    "description": "This insurer is rated C- (Weak) by AM Best, showing a weak and highly precarious ability to meet ongoing insurance obligations."
  },
  "D": {
    "title": "D (Poor) – AM Best Rating",
    "description": "This insurer is rated D (Poor) by AM Best, indicating the company is in default or has a poor ability to meet insurance obligations."
  },
  "E": {
    "title": "E (Under Regulatory Supervision) – AM Best Rating",
    "description": "This insurer is rated E by AM Best, meaning it is under regulatory supervision; its ability to meet insurance obligations is uncertain pending regulatory action."
  },
  "F": {
    "title": "F (In Liquidation) – AM Best Rating",
    "description": "This insurer is rated F by AM Best, denoting that the company is being liquidated and its insurance obligations are handled through liquidation proceedings."
  },
  "S": {
    "title": "S (Rating Suspended) – AM Best Rating",
    "description": "AM Best has suspended this insurer's rating (S) due to insufficient information or circumstances preventing a reliable evaluation of its financial strength."
  }
};

export const AM_BEST_CARRIER_RATINGS: Record<string, string> = {
  "OneAmerica": "A+",
  "Nationwide": "A+",
  "Lincoln Financial": "A+",
  "Securian Financial": "A+"
}; 